export default "__VITE_ASSET__B3Qb6xfj__"